import Rupees, { rupees } from '@instamojo/rupee';
import classnames from 'classnames';
import React from 'react';

export interface RupeeProps {
  value?: string;
  defaultClass?: boolean;
}

const Rupee: React.FC<RupeeProps> = ({ value, defaultClass = true }) => {
  return (
    <div className="flex justify-end">
      <div className={classnames('', { 'text-14 mr-1': defaultClass })}>
        <Rupees />
      </div>
      <div>{rupees(value)}</div>
    </div>
  );
};

export default Rupee;
